import React, { useState, createContext } from "react";

export const ScenarioSection = createContext({
  scenarioPage: {},
  ShowHideFunction: () => {},
});

const ScenarioContextProvider = (props) => {
  const [scenarioPage, setScenarioPage] = useState({
    firstPage: true,
    addPage: false,
    deviceDetails: false,
  });

  const ShowHideFunction = (page) => {
    switch (page) {
      case "firstPage":
        setScenarioPage({
          firstPage: true,
          addPage: false,
          deviceDetails: false,
        });
        break;
      case "addPage":
        setScenarioPage({
          firstPage: false,
          addPage: true,
          deviceDetails: false,
        });
        break;
      case "deviceDetails":
        setScenarioPage({
          firstPage: false,
          addPage: false,
          deviceDetails: true,
        });
        break;
    }
  };

  return (
    <>
      <ScenarioSection.Provider value={{ scenarioPage, ShowHideFunction }}>
        {props.children}
      </ScenarioSection.Provider>
    </>
  );
};

export { ScenarioContextProvider };
